import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { each, get } from 'lodash';
import { map } from "rxjs/operators";
import { of } from 'rxjs';

import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { ExtendedHttpResponse, HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';

@Injectable()
export class PractitionerService {
  private readonly baseUrl = '/practitioner';

  private practitionersByRole = { };

  constructor(
    private http: HttpInterceptorService,
    private authService: AuthenticationService
  ) {
  }

  public getPractitionersByRole(role: string) {
    if (this.practitionersByRole[role]) {
      return of(this.practitionersByRole[role]);
    } else {
      const params = { _fieldslist: 'id,name', _sort: 'family' };

      if (this.authService.user.info) {
        params['organization'] = this.authService.user.info.practitionerRole[0].managingOrganization;
        params['role'] = role;
      }

      return this.http.get(this.baseUrl, params)
        .pipe(
          map((res: ExtendedHttpResponse<any>) => {
              each(res.body, (pract: any) => {
                pract.fullName =
                  this.getValue(pract, 'name[0].prefix[0]') + '. ' +
                  this.getValue(pract, 'name[0].given[0]') + ' ' +
                  this.getValue(pract, 'name[0].family[0]') + ' ' +
                  this.getValue(pract, 'name[0].suffix[0]');
              });

              this.practitionersByRole[role] = res.body;

              return res.body;
            }
          )
        );
    }
  }

  public get(id: string): Observable<ExtendedHttpResponse<any>> {
    return this.http.get(this.baseUrl + '/' + id);
  }

  private getValue(value: any, path: string): any {
    return get(value, path, '');
  }
}


